export default __webpack_public_path__ + "static/media/542.093af43a.jpg";